// extracted by mini-css-extract-plugin
export var completionBody = "_kf-2";
export var completionCard = "_kf-0";
export var completionFooter = "_kf-3";
export var completionTitle = "_kf-1";